import { setSelectedFile } from 'store/slices/selectedFile';
import insertContent from './insertContent';

const onFileManagerUpload = (editor, row, dispatch, request) => {
  const data = {
    image: () =>
      insertContent(editor, {
        type: 'img',
        attrs: {
          src: row.fullPath,
          alt: 'peer-tree image',
        },
      }),
    video: async () => {
      const { data: videoResponse } = await request({ metaId: row.id });
      editor
        ?.chain()
        .focus()
        .setShortCode({
          id: videoResponse.id,
          src: row.fullPath,
          type: 'video',
        })
        .run();
    },
    pdf: () =>
      insertContent(editor, {
        type: 'pdf',
        attrs: {
          src: row.fullPath,
        },
      }),
    doc: () =>
      insertContent(editor, {
        type: 'document',
        attrs: {
          href: row.fullPath,
          name: row.name,
        },
      }),
    audio: async () => {
      const { data: audioResponse } = await request({ metaId: row.id });
      editor
        ?.chain()
        .focus()
        .setShortCode({
          id: audioResponse.id,
          src: row.fullPath,
          type: 'audio',
        })
        .run();
    },
  };

  dispatch(setSelectedFile({ file: null }));
  return data[row.type]?.();
};

export default onFileManagerUpload;
